<!-- Иконка веса: напольные весы для массы груза. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <rect
      x="4"
      y="4"
      width="16"
      height="16"
      rx="3"
      :stroke="stroke"
      stroke-width="2"
    />
    <path
      d="M8 10C8.7 8.2 10.1 7 12 7C13.9 7 15.3 8.2 16 10"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M12 7V10"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M9 16H15"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: "WeightIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
